<template>
  <bulma-tooltip wrap-text type="is-light is-primary"
                 :label="label"
                 :force-visible="forceVisible"
                 :fixed-width="toolTipWidth"
                 :position="toolTipPosition"
  >
    <span class="tag is-success ml-1">
      <i class="icon fas fa-star mr-1"></i>
      {{ $t('tryThis') }}
    </span>
  </bulma-tooltip>
</template>
<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import BulmaTooltip from "@/components/common/BulmaTooltip.vue";

const props = defineProps({
  label: {
    type: String,
    required: true
  },
  localStorageProperty: {
    type: String,
    required: true
  },
  toolTipWidth: {
    type: String,
    required: true
  },
  toolTipPosition: {
    type: String,
    required: true
  }
})

const forceVisible = ref(false)

onMounted(() => {
  const localStorageProp = localStorage.getItem(props.localStorageProperty)
  forceVisible.value = localStorageProp == null || localStorageProp === 'false'
  if (forceVisible.value) {
    window.addEventListener('click', onGlobalClick, true)
    localStorage.setItem(props.localStorageProperty, 'true')
  }
})

const onGlobalClick = () => {
  //clicking ANYWHERE in the UI needs to set forceVisible to false
  forceVisible.value = false
}

watch(forceVisible, (value, oldValue) => {
  if (typeof window === 'undefined') return
  if (value === oldValue) return
  if (!value) {
    window.removeEventListener('click', onGlobalClick, true)
  }
})

onBeforeUnmount(() => {
  if (typeof window === 'undefined') return
  window.removeEventListener('click', onGlobalClick, true)
})
</script>
<style scoped>
.tag.is-success {
  background-color: var(--primary);
  color: var(--primary--color-invert);
}
</style>
